import {
  isAppPage,
  isLoginPage,
  isEmbeddedPage,
  isRegistrationPage,
  isPublicRoute,
  isHybridRoute
} from './helper/pages.ts';
import { fnComponentsModuleName } from '@farmnet/components';

import { farmnetBaseModule } from "./modules/farmnet/base/farmnet.base.module";

import { angularModuleLoadingModule} from '../common/module-loading/module-loading.module.ts';
import '@farmnet/feature-toggle/dist/farmnet-featuretoggle.js';
import 'oclazyload';

//workaround for use strict and basic definition of required modules
var app = angular.module('cfn', [
  farmnetBaseModule,
  'farmnet.planning',
  'farmnet.partner.externalAccounts',
  'farmnet.partner.fendt',
  'farmnet.featuretoggle',
  'ngRoute',
  'ngResource',
  'angularLocalStorage',
  'cfn.services',
  'oc.lazyLoad',
  fnComponentsModuleName,
  angularModuleLoadingModule,
]);
app.constant('app', app);
app.getModuleSettings = () => {};
app.isAppPage = isAppPage;
app.isLoginPage = isLoginPage;
app.isEmbeddedPage = isEmbeddedPage;
app.isRegistrationPage = isRegistrationPage;
app.isPublicRoute = isPublicRoute;
app.isHybridRoute = isHybridRoute;
app.modules = [];

let pageSearch = location.search.substring(1);
app.pageSearch = pageSearch === '' || pageSearch === '/' ? '' : pageSearch; // without ? search parameter and also without root "?/"

app.routeRights = app.routeRights || {};

app.addRouteRight = addRouteRight;

app.backlinkRoutes = {};
app.registerBacklinkRoute = registerBacklinkRoute;

// corrects wrong backlinks if something that is part of planning is called via core
app.getBacklinkRoute = getBacklinkRoute;

function addRouteRight(route, right) {
  app.routeRights[route] = right;
}

function registerBacklinkRoute(name, route) {
  app.backlinkRoutes[name] = route;
}

function getBacklinkRoute(name) {
  if (name.indexOf('core/') != -1) {
    name = name.substr(name.indexOf('core/') + 5, name.length);
  }
  var rest = '';
  if (name.indexOf('/') != -1) {
    rest = name.substr(name.indexOf('/'), name.length);
    name = name.substr(0, name.indexOf('/'));
  }
  var result = app.backlinkRoutes[name];
  console.debug('Got backlink route', name, '+', result, '+', rest);
  if (!result) return null;
  else return result + rest;
}

global.app = app;

export default app;
